/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFullfilmentBox = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M11.47 2.152a1 1 0 0 1 1.06 0l8 5A1 1 0 0 1 21 8v5.222l-1.757-1.757-.243.242V9.804l-6 3.75v7.982h.03l-.5.312a1 1 0 0 1-1.06 0l-8-5A1 1 0 0 1 3 16V8a1 1 0 0 1 .47-.848zM5 9.804v5.642l6 3.75v-5.642zm7 2.017L18.113 8 12 4.18 5.887 8z" />
        <path d="M19.657 19.536H15v-2h4.657l-1.829-1.829 1.415-1.414 4.242 4.243-4.242 4.242-1.415-1.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgFullfilmentBox as FullfilmentBox };
